import { render, staticRenderFns } from "./ItemRentUpdate.vue?vue&type=template&id=9fb8636c&scoped=true&"
import script from "./ItemRentUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemRentUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ItemRentUpdate.vue?vue&type=style&index=0&id=9fb8636c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb8636c",
  null
  
)

export default component.exports